import { render } from "./DragHelper.vue?vue&type=template&id=fae8e7d4"
import script from "./DragHelper.vue?vue&type=script&lang=js"
export * from "./DragHelper.vue?vue&type=script&lang=js"
script.render = render

export default script